import $ from 'jquery';

class Woocommerce {

    constructor() {

        $(document).ready(() => {
            this.firstName = $('#billing_first_name');
            this.currentInput = $('.input-text');
            this.formEvent = $('.woocommerce-billing-fields__field-wrapper');
            this.woocommerceFlex = $('.c-woocommerce-form');
            this.selectListener();
            this.focusLisener();
            this.textareaLisener();
        });

    }

    textareaLisener() {
        $('#order_comments').on('focus', (e) => {
            $('.woocommerce-additional-fields h3').addClass('textarea-focus');
        });
        $('#order_comments').on('blur', (e) => {
            $('.woocommerce-additional-fields h3').toggleClass('textarea-focus', e.currentTarget.value.length !== 0);
        });
    }

    selectListener() {
        jQuery('#billing_country').on('change', () => {
            $('.billing_country ').toggleClass('focused');
            setTimeout(() => {
                this.focusLisener();
            }, 400)
        });
        jQuery('#billing_state').on('change', () => {
            $('.billing_state').toggleClass('focused');
            setTimeout(() => {
                this.focusLisener();
            }, 400)
        });
    }

    focusLisener() {
        this.formEvent.find('.form-row').each((ind, el) => {
            (function (ell) {
                $(ell).find('input').off().on('focus', (e) => {
                    $(ell).find('label').addClass('focused');
                });
                $(ell).find('input').on('blur ', (e) => {
                    $(ell).find('label').toggleClass('focused', e.currentTarget.value.length !== 0);
                });
            })(el);
        });
    }

}

export default Woocommerce;